import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';

interface Props {
  readonly onSelectAction: (path: string) => void,
}

export const ViewDeploymentsContainer = (props: Props) => {

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <Card>
          <CardHeader title="View Deployments" />
          <CardActions>
            <Button
              onClick={() => props.onSelectAction('view')}
              size="small"
            >View</Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  );
}

export default ViewDeploymentsContainer;